(function () {
  var rubs = {
    "Carni Rub": "Our signature house rub. A smoky paprika base, mixed peppercorns, garlic, mustard, and coriander create a bold yet versatile blend.",
    "Coffee Rub": "Carni Rub with a hit of coffee for added depth!",
    "Chicken Rub": "Garlic, smoked paprika, thyme, and parsley for a fragrant, herby mix.",
    "Salt n Pepper": "Simple, timeless balance of sea salt and cracked pepper.",
    "Miyagi Rub": "Fiery wasabi, garlic, ginger, onion, and pepper deliver a bold, aromatic punch.",
    "Sweet n Heat": "A bit sweet and a bit spicy, just as you would expect. Brown sugar meets cayenne, paprika, garlic, and onion.",
    "Yalla Beena": "Warm, fragrant Middle Eastern spice mix with sumac, garlic, and mixed herbs.",
    "Bollywood": "Vibrant, aromatic curry blend with garam masala, chili, garlic, onion, coriander, and turmeric."
  };
  var marinades = {
    "CarniQ": "Smoky, savory, and not too sweet. BBQ sauce done our way!",
    "CarniBBQ": "Smoky, savory, and not too sweet. BBQ sauce done our way!",
    "Smokin' Peaches": "Juicy peach with honey, jalapeno, olive oil, and CarniQ for a smoky, fruity zing.",
    "Majlis": "Creamy yogurt, garlic, onions, Arabic spices, and olive oil for rich, aromatic depth.",
    "Special House Marinade": "Fruit and vegetable extracts that naturally tenderize meat and subtly boost flavor.",
    "Miyagi": "Umami-rich oyster sauce, soy, honey, ginger, garlic, and sesame seeds for a nutty, savory profile.",
    "Miso": "Sweet, salty, and umami with miso, soy, brown sugar, sesame, oyster sauce, and ginger.",
    "Moutarde": "Tangy Dijon mustard with black pepper, tarragon, parsley, and olive oil for herby, zesty notes.",
    "Special Lamb Marinade / Riyash": "Onion, thyme, salt, pepper, and olive oil combine for a simple, aromatic herb blend."
  };
  var map = {
    "carnirub": "Carni Rub", "carni rub": "Carni Rub", "coffee rub": "Coffee Rub", "chicken rub": "Chicken Rub",
    "salt & pepper": "Salt n Pepper", "salt and pepper": "Salt n Pepper", "salt n pepper": "Salt n Pepper",
    "miyagi rub": "Miyagi Rub", "sweet & heat": "Sweet n Heat", "sweet n heat": "Sweet n Heat",
    "yalla beena": "Yalla Beena", "bollywood": "Bollywood", "carniq": "CarniQ", "carnibbq": "CarniBBQ",
    "smokin peaches": "Smokin' Peaches", "smokin' peaches": "Smokin' Peaches", "majlis": "Majlis", "majilis": "Majlis",
    "special house marinade": "Special House Marinade", "house marinade": "Special House Marinade",
    "miyagi": "Miyagi", "mr. miyagi": "Miyagi", "mr miyagi": "Miyagi", "miso": "Miso", "moutarde": "Moutarde",
    "buffalo": "Buffalo",
    "riyash marinade": "Special Lamb Marinade / Riyash", "special lamb marinade": "Special Lamb Marinade / Riyash"
  };
  // Allergens per rub/marinade (source: /pages/allergens). 'free' = free from allergens,
  // otherwise a list of [label, level] where level is 'yes' or 'maybe'.
  var allergens = {
    "Carni Rub": [["Mustard", "yes"]],
    "Coffee Rub": [["Mustard", "yes"]],
    "Chicken Rub": "free",
    "Salt n Pepper": "free",
    "Miyagi Rub": "free",
    "Sweet n Heat": "free",
    "Yalla Beena": "free",
    "Bollywood": "free",
    "CarniQ": [["Fish", "yes"], ["Egg", "maybe"], ["Dairy", "maybe"], ["Gluten", "yes"], ["Mustard", "yes"], ["Sulphur Dioxide & Sulphites", "yes"]],
    "CarniBBQ": [["Fish", "yes"], ["Egg", "maybe"], ["Dairy", "maybe"], ["Gluten", "yes"], ["Mustard", "yes"], ["Sulphur Dioxide & Sulphites", "yes"]],
    "Smokin' Peaches": [["Fish", "yes"], ["Egg", "maybe"], ["Dairy", "maybe"], ["Gluten", "yes"], ["Mustard", "yes"], ["Sulphur Dioxide & Sulphites", "yes"]],
    "Miyagi": [["Crustacean", "yes"], ["Mollusks", "yes"], ["Fish", "yes"], ["Sesame", "yes"], ["Soy", "yes"], ["Gluten", "yes"]],
    "Miso": [["Crustacean", "yes"], ["Mollusks", "yes"], ["Fish", "yes"], ["Sesame", "yes"], ["Soy", "yes"], ["Gluten", "yes"]],
    "Majlis": [["Dairy", "yes"]],
    "Moutarde": [["Mustard", "yes"]],
    "Special House Marinade": "free",
    "Special Lamb Marinade / Riyash": "free",
    "Buffalo": "free"
  };
  function allerHTML(v, compact){
    var a = allergens[v];
    if (!a) return '';
    if (compact) {
      if (a === 'free') return ' <span class="carni-rub-aller--inline carni-rub-aller__row--free">Allergen-free</span>';
      var y = [], m = [];
      a.forEach(function(x){ (x[1] === 'yes' ? y : m).push(x[0]); });
      var s = ' <span class="carni-rub-aller--inline">';
      if (y.length) s += '<span class="carni-rub-aller__k carni-rub-aller__k--yes">Contains:</span> ' + y.join(', ');
      if (m.length) s += (y.length ? ' &middot; ' : '') + '<span class="carni-rub-aller__k carni-rub-aller__k--maybe">May contain:</span> ' + m.join(', ');
      return s + '</span>';
    }
    if (a === 'free') {
      return '<span class="carni-rub-aller"><span class="carni-rub-aller__title">Allergens</span><span class="carni-rub-aller__row carni-rub-aller__row--free">Free from allergens</span></span>';
    }
    var yes = [], maybe = [];
    a.forEach(function(x){ (x[1] === 'yes' ? yes : maybe).push(x[0]); });
    var rows = '';
    if (yes.length) rows += '<span class="carni-rub-aller__row"><span class="carni-rub-aller__k carni-rub-aller__k--yes">Contains:</span> ' + yes.join(', ') + '</span>';
    if (maybe.length) rows += '<span class="carni-rub-aller__row"><span class="carni-rub-aller__k carni-rub-aller__k--maybe">May contain:</span> ' + maybe.join(', ') + '</span>';
    return '<span class="carni-rub-aller"><span class="carni-rub-aller__title">Allergens</span>' + rows + '</span>';
  }
  function info(v, compact){
    var d = desc(v);
    return '<strong>' + v + '</strong>' + (d ? ' - ' + d : '') + allerHTML(v, compact);
  }
  // Normalise punctuation (apostrophes, &, hyphens, dots) to spaces so "Sweet'N'Heat",
  // "Salt & Pepper", "Smokin' Peaches" etc. all match their space-separated keys.
  function clean(s){ return (s || '').toLowerCase().replace(/[’'`&.\-_/]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  var names = Object.keys(rubs).concat(Object.keys(marinades));
  function matchVal(text){
    if (!text) return null;
    var c = clean(text);
    if (map[c]) return map[c];
    if (rubs[c] || marinades[c]) return c;
    for (var i = 0; i < names.length; i++){ if (c.indexOf(clean(names[i])) !== -1) return names[i]; }
    for (var k in map){ if (c.indexOf(k) !== -1) return map[k]; }
    return null;
  }
  function desc(v){ return rubs[v] || marinades[v]; }

  // Boot once for the whole document (covers the PDP picker and the dynamically-injected quick-view).
  if (window.__carniRubsBooted) return;
  window.__carniRubsBooted = true;

  // Desktop = cursor-following tooltip; mobile / narrow = fixed inline panel(s).
  var hoverCapable = false;
  try { hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.matchMedia('(min-width: 768px)').matches; } catch (e) {}

  if (hoverCapable) {
    var tip = document.createElement('div');
    tip.className = 'carni-rub-tip'; tip.setAttribute('role', 'tooltip'); tip.hidden = true;
    function mountTip(){ if (document.body && !tip.parentNode) document.body.appendChild(tip); }
    mountTip(); document.addEventListener('DOMContentLoaded', mountTip);
    var curV = null;
    function place(x, y){
      var pad = 10, w = tip.offsetWidth, h = tip.offsetHeight;
      var left = x + 16, top = y + 18;
      if (left + w > window.innerWidth - pad) left = x - 16 - w;
      if (top + h > window.innerHeight - pad) top = y - 18 - h;
      if (left < pad) left = pad;
      if (top < pad) top = pad;
      tip.style.left = Math.round(left) + 'px';
      tip.style.top = Math.round(top) + 'px';
    }
    document.addEventListener('mousemove', function(e){ if (curV) place(e.clientX, e.clientY); }, { passive: true });
    // Delegated hover so it covers BOTH the PDP variant picker and the quick-view modal. Matches only
    // option elements inside a product form / variant picker, so it never fires on unrelated page text.
    function valueForNode(target){
      if (!target || !target.closest) return null;
      var node = target.closest('label, [data-value], .variant-input, button');
      if (!node) return null;
      if (!node.closest('.product-form, .main-product-form, product-info, variant-selects')) return null;
      var raw = (node.dataset && node.dataset.value) ? node.dataset.value : ((node.querySelector && node.querySelector('input')) ? node.querySelector('input').value : node.textContent);
      return matchVal(raw);
    }
    document.addEventListener('mouseover', function(e){
      var v = valueForNode(e.target);
      if (!v) return;
      mountTip();
      curV = v; tip.innerHTML = info(v); tip.hidden = false; place(e.clientX, e.clientY);
      requestAnimationFrame(function(){ tip.style.opacity = '1'; });
    });
    document.addEventListener('mouseout', function(e){
      if (!curV) return;
      var from = valueForNode(e.target);
      var to = valueForNode(e.relatedTarget);
      if (from && !to) { curV = null; tip.hidden = true; tip.style.opacity = '0'; }
    });
  } else {
    // Fill every .carni-rubs panel with the selection of its own product container.
    function fillWrap(wrap){
      var content = wrap.querySelector('.carni-rubs__content');
      if (!content) return;
      var scope = wrap.closest('product-info, .quick-view__content, .product, .main-product-form, form') || document;
      var out = [], seen = {};
      scope.querySelectorAll('input[type=radio]:checked, select option:checked').forEach(function(el){
        var v = matchVal(el.value); if (v && !seen[v]) { seen[v] = 1; out.push(v); }
      });
      if (!out.length) { wrap.hidden = true; content.innerHTML = ''; return; }
      content.innerHTML = out.map(function(v){ return '<div class="carni-rubs__item">' + info(v, true) + '</div>'; }).join('');
      wrap.hidden = false;
    }
    function showSelected(){ document.querySelectorAll('.carni-rubs').forEach(fillWrap); }
    document.addEventListener('change', function(e){ if (e.target && e.target.matches && e.target.matches('input, select')) showSelected(); });
    document.addEventListener('DOMContentLoaded', showSelected);
    document.addEventListener('shopify:section:load', showSelected);
    document.addEventListener('quick-view:loaded', function(){ setTimeout(showSelected, 60); });
    showSelected();
  }
})();
